import React from 'react';
import '../App.css';

const Guidelines = () => {
const rules = [
  { id: 1, text: "Registration can be done online or offline. On-spot registration will be available only for events with vacant slots and will operate on a first-come, first-served basis." },
  { id: 2, text: "On-spot registrations will begin at 8:00 AM and close at 9:30 AM on 4th December." },
  { id: 3, text: "Each student can participate in only ONE event, as all events will run simultaneously." },
  { id: 4, text: "Last date for online registration: 2nd December." },
  { id: 5, text: "Registration proof and a valid college ID card are mandatory and must be presented during registration and throughout the event." },
  { id: 6, text: "All team members must be from the same college." },
  { id: 7, text: "Participants must bring their own electronic devices; no devices will be provided by the college." },
  { id: 8, text: "Events will commence as per the scheduled timings; punctuality is expected and delays will not be accommodated." },
  { id: 9, text: "Any form of misbehavior, indiscipline, vulgarity, malpractice or consumption of any state-altering substances on campus will lead to immediate disqualification." },
  { id: 10, text: "Judges' and coordinators' decisions will be final and binding." },
  { id: 11, text: "The organizers reserve the right to reschedule or cancel events due to unforeseen circumstances." },
  { id: 12, text: "The college/management will not be responsible for any loss of valuables or personal belongings." },
  { id: 13, text: "Accommodation will be provided only to participants from other districts who qualify for the final round." },
  { id: 14, text: "For any queries or registration-related issues, please contact the Event Coordinators or the Help Desk." },
  { id: 15, text: "All events offering on-spot registration will conduct it exclusively on 4th December, except Wano Rhythms Arena. Since this event will be held only on 5th December, its on-spot registration will take place solely on that day." }
];

  return (
    <section id="guidelines" className="py-5">
      <div className="container">
        <div className="section-header text-center mb-3">
          <h2 className="section-title">Event Guidelines</h2>
        </div>
        
        <div className="guidelines-grid">
          {rules.map((rule) => (
            <div key={rule.id} className="guideline-item">
              <div className="guideline-number">{rule.id}.</div>
              <div className="guideline-text">{rule.text}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Guidelines;
